import { getSession } from '../../auth/session-store';
import { apiGet } from '../client';
import { BusinessReportResponseSchema, type BusinessReport, type ReportExportKind } from '../schemas';

export type ReportRange = { from: string; to: string };

function rangeQuery(range: ReportRange): string {
  return new URLSearchParams({ from: range.from, to: range.to }).toString();
}

export async function getBusinessReport(range: ReportRange): Promise<BusinessReport> {
  const response = await apiGet(`/v1/business/reports?${rangeQuery(range)}`, BusinessReportResponseSchema);
  return response.data;
}

/**
 * The contador's CSV. Fetched with the session (a bearer session cannot ride on
 * a plain link) and handed to the browser as a file named after the period.
 */
export async function downloadReportExport(kind: ReportExportKind, range: ReportRange): Promise<void> {
  const session = getSession();
  const response = await fetch(`/v1/business/reports/export?${rangeQuery(range)}&kind=${kind}`, {
    credentials: 'include',
    headers: session?.transport === 'bearer' && session.token ? { Authorization: `Bearer ${session.token}` } : {},
  });
  if (!response.ok) throw new Error(`report export ${response.status}`);
  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `dale-${kind}-${range.from}-a-${range.to}.csv`;
  document.body.append(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
